import React from "react";
import Seo from "@/components/Seo";

export default function MentionsLegalesPage() {
  return (
    <div className="container-x py-16 max-w-3xl" data-testid="mentions-legales-page">
      <Seo
        title="Mentions légales"
        description="Mentions légales du site Recette-Diabete : éditeur, hébergement, propriété intellectuelle."
        path="/mentions-legales"
      />
      <p className="overline mb-3">Informations légales</p>
      <h1 className="font-serif text-4xl md:text-5xl mb-8">Mentions légales</h1>

      <div className="prose max-w-none space-y-6 text-[hsl(var(--text-secondary))]">
        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">Éditeur du site</h2>
          <p>
            <strong>OPTIMHUB</strong><br />
            Société par actions simplifiée à associé unique (SASU) au capital de 5&nbsp;001&nbsp;€<br />
            Siège social : 11 rue de Lourmel, 75015 Paris, France<br />
            RCS Paris : 534&nbsp;057&nbsp;088<br />
            SIRET : 534&nbsp;057&nbsp;088&nbsp;00039<br />
            N° TVA intracommunautaire : FR63534057088<br />
            Code APE : 7021Z (Conseil en relations publiques et communication)<br />
            Email : contact@recette-diabete.com
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">Directeur de la publication</h2>
          <p>Julien Bosselut, en qualité de représentant légal de la société BOSS CORP, présidente d'OPTIMHUB.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">Hébergement</h2>
          <p>
            Ce site est hébergé par la plateforme <strong>Emergent</strong>, avec distribution via&nbsp;:<br />
            <strong>Cloudflare, Inc.</strong> — 101 Townsend St, San Francisco, CA 94107, États-Unis<br />
            <a href="https://www.cloudflare.com" target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--brand-primary))] underline">www.cloudflare.com</a>
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">Propriété intellectuelle</h2>
          <p>
            L'ensemble du contenu du site Recette-Diabete (textes, recettes, guides, images, illustrations
            générées par intelligence artificielle, code source, charte graphique) est la propriété
            exclusive d'OPTIMHUB, sauf mention contraire, et est protégé par le droit français et
            international de la propriété intellectuelle.
          </p>
          <p>
            Toute reproduction, représentation, modification, publication ou adaptation totale ou partielle
            des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans
            l'autorisation écrite préalable de l'éditeur, sauf exceptions prévues par la loi.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">Avertissement médical</h2>
          <p>
            Les recettes et guides publiés sur Recette-Diabete sont fournis à titre informatif et
            pédagogique. Ils <strong>ne remplacent en aucun cas un avis médical, un diagnostic ou un
            traitement</strong>. Les personnes diabétiques doivent consulter leur médecin, diététicien
            ou endocrinologue avant toute modification de leur alimentation. L'éditeur ne saurait
            être tenu responsable de l'usage fait des informations publiées.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">Liens hypertextes</h2>
          <p>
            Le site Recette-Diabete peut contenir des liens vers des sites tiers. OPTIMHUB n'exerce
            aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou à
            l'usage qui pourrait en être fait.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-[hsl(var(--text-primary))] mb-3">Contact</h2>
          <p>
            Pour toute question, écrivez-nous à{" "}
            <a href="mailto:contact@recette-diabete.com" className="text-[hsl(var(--brand-primary))] underline">
              contact@recette-diabete.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
